window.$ = window.jQuery = require('jquery');

require('./slick.js');
require('./masonry.pkgd.min.js');
require('./jquery.marquee.min.js');
require('./jquery.arcticmodal-0.3.min.js');
require('./select2.min.js');

import sal from './sal.js'

$(document).ready(function () {
    //marquee
    $('.js-marquee').marquee({
        duration: 20000,
        gap: 0,
        delayBeforeStart: 0,
        direction: 'left',
        duplicated: true,
        duplicateCount: 3,
        startVisible: true
    });

    // fadeIn
    sal();

	// scroll to element
	if (window.location.hash) {
		setTimeout(function(){
			scrollToSection(window.location.hash);
		}, 50);
	}

	$('a[href*="#"]').on('click', function (e) {
		e.preventDefault();
        if (this.hash.length>0) {
            if (this.pathname === window.location.pathname) {
                scrollToSection(this.hash);
            }
            else {
                window.location.replace(this.href);
            }
        }
	});

    function scrollToSection(id) {
        let header = $('header');
        if($(window).innerWidth() < 992){
            closeMenu();
            $('html, body').animate({
                scrollTop: $(id).offset().top-80
            }, 1000);
        } else {
            $('html, body').animate({
                scrollTop: $(id).offset().top-90
            }, 1000);
        }
    }

	// fix header
	let headerHeightSet = false;
	let headerHeight;

	$(window).on('scroll', function(){
		let header = $('.header'),
				scroll = $(window).scrollTop();

		if (!headerHeightSet) {
			headerHeight = header.outerHeight(true);
			headerHeightSet = true;
		}
		
		if (scroll >= headerHeight) {
			header.addClass('fixed');
		} else {
			header.removeClass('fixed');
		}
	});

	// burger menu
	function openMenu(){
		$('body').css({'overflow': 'hidden'});
		$('.js-burger-open').addClass('opened');
		$('.header').addClass('opened');
	}

	function closeMenu(){
		$('body').css({'overflow': ''});
		$('.js-burger-open').removeClass('opened');
		$('.header').removeClass('opened');
	}

	$('.js-burger-open').on('click', function(){
		if($('.header').hasClass('opened')){    
			closeMenu();
		} else {
			openMenu();
		}

		return false;
	});

	$(window).on('resize', function(){
		if ($(window).width() > 766) {
			closeMenu();
		}
	});

    // header submenu
    $('.header li.menu-item-has-children').on('click', function(){
        $('.header li.menu-item-has-children').not(this).find('.sub-menu').stop( true, true ).slideUp(150);
        $('.header li.menu-item-has-children').not(this).find('a').removeClass('active');

        $(this).find('.sub-menu').stop( true, true ).slideToggle(150);
        $(this).find('a').toggleClass('active');
    });
    $(document).on('mouseup', function(e){
        var div = $('.header li.menu-item-has-children');
        if ( !div.is(e.target) && div.has(e.target).length === 0 ) {
            $('.header li.menu-item-has-children').find('.sub-menu').stop( true, true ).slideUp(150);
            $('.header li.menu-item-has-children').find('a').removeClass('active');
        }
    });

	// cursor follow on hero block
	$(function(){
		if ($('.hero-container').length > 0) {
			var mouseX = 0, mouseY = 0, containerWidth = $('.hero-container').width(), containerHeight = $('.hero-container').height(), limitX = containerWidth-10, limitY = containerHeight-10;

			$(window).on('mousemove', function(e){
				var offset = $('.hero-container').offset();
				mouseX = Math.min(e.pageX - offset.left, limitX);
				mouseY = Math.min(e.pageY - offset.top, limitY);
				if (mouseX < 0) mouseX = 0;
				if (mouseY < 0) mouseY = 0;
			});

			var follower = $('.hero-cursor');
			var xp = 0, yp = 0;
			var loop = setInterval(function(){
				xp += (mouseX - xp) / 5;
				yp += (mouseY - yp) / 5;
				follower.css({left:xp, top:yp});
					
			}, 10);
		}
	});

    // hero count
    $('.hero-items-item span').each(function () {
        const $this = $(this);

        const target = $this.data('count').toString();
        const hasPlus = target.includes('+');
        const hasPercent = target.includes('%');

        const number = parseInt(target, 10);

        $({ countNum: 0 }).animate(
            { countNum: number },
            {
                duration: 3000,
                easing: 'swing',
                step: function () {
                    $this.text(Math.floor(this.countNum) + (hasPercent ? '%' : ''));
                },
                complete: function () {
                    $this.text(number + (hasPercent ? '%' : '') + (hasPlus ? '+' : ''));
                }
            }
        );
    });

	// slider testimonials
    $('.js-sliderTestimonials').on('init', function(event, slick) {
        readMoreTestimonials();
    });

    $('.js-sliderTestimonialsMin').on('init', function(event, slick) {
        readMoreTestimonials();
    });

    $('.js-sliderTestimonials').slick({
        nextArrow: $('.js-sliderTestimonialsNext'),
        prevArrow: $('.js-sliderTestimonialsPrev'),
        appendDots: $('.slider-controls'),
        dots: true,
        slidesToShow: 3,
        slidesToScroll: 1,
        variableWidth: true,
    });

    $('.js-sliderTestimonialsMin').slick({
        nextArrow: $('.js-sliderTestimonialsMinNext'),
        prevArrow: $('.js-sliderTestimonialsMinPrev'),
        appendDots: $('.slider-controls'),
        dots: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        centerMode: true,
        variableWidth: true,
    });

    function readMoreTestimonials() {
        if($('.js-testimComment').length > 0) {
            $('.js-testimComment').each(function(){
                if ($(this).closest('.js-testimCont').find('.js-tesimRm').length == 0 && $(this).height() > 121) {
                    $(this).height(120);
                    $(this).css('-webkit-line-clamp', '6');
                    $(this).closest('.js-testimCont').append('<span class="slider-content-item-more js-tesimRm">'+$('.js-testimComment').data('text')+'</span>')
                }
            })
        }
    }

    $(window).on('resize', function () {
        readMoreTestimonials();
    });

    $('body').on('click', '.js-tesimRm', function(e){
        const content = $(this).closest('.js-testimCont').clone();

        $('.js-testimFullCont').html(content);
        $('.js-testimFullCont').prepend('<div class="modal-testimonials-close arcticmodal-close"></div>');
        $('.js-testimFullCont').find('.js-testimCont').css('width', '100%');
        $('.js-testimFullCont').find('.js-tesimRm').remove();
        $('.js-testimFullCont').find('.js-testimComment').css('height', 'auto');
        $('.js-testimFullCont').find('.js-testimComment').css('-webkit-line-clamp', 'unset');
        $('.js-testimFullCont').find('.js-testimComment').removeClass('js-testimComment');
        $('.js-testimFullModal').arcticmodal({
            overlay: {
                css: {
                    backgroundColor: '#18191F',
                    opacity: .25
                }
            }
        });

        return false;
    })

	// accordeon
	$('.js-accordeonItemTitle').on('click', function() {
		let elem = $(this).closest('.js-accordeonItem');
		let elemId = elem.data('id');
		let image = $('.js-accordeonItemImage[data-id="'+elemId+'"]');

		let allElem = $('.js-accordeonItem');
		let allImage = $('.js-accordeonItemImage');

		allElem.removeClass('active');
		allImage.removeClass('active');

		elem.addClass('active');
		image.addClass('active');
	});

	// load more cases
	let currentPageCase = 1;
	$('.js-loadMoreCaseBtn').on('click', function() {
		currentPageCase++;

		const button = $(this);
		const content = $('.js-loadMoreCaseContent');

		button.prop('disabled', true);		

		$.ajax({
			type: 'POST',
			url: '/wp-admin/admin-ajax.php',
			dataType: 'json',
			data: {
				action: 'case_load_more',
				paged: currentPageCase,
			},
			success: function (res) {
				button.prop('disabled', false);
				if(currentPageCase >= res.max) {
					button.hide();
				}
				content.append(res.html);

                sal();
			}
		});
	});

	// load more posts
	let currentPagePost = 1;
	$('.js-loadMorePostBtn').on('click', function() {
		currentPagePost++;

		const button = $(this);
		const content = $('.js-loadMorePostContent');

		button.prop('disabled', true);

		let data;

		if ($(this).data('cat')) {
			data = {
				cat: $(this).data('cat'),
				action: 'post_load_more',
				paged: currentPagePost
			}
		} else {
			data = {
				action: 'post_load_more',
				paged: currentPagePost,
			}
		}

		$.ajax({
			type: 'POST',
			url: '/wp-admin/admin-ajax.php',
			dataType: 'json',
			data: data,
			success: function (res) {
				button.prop('disabled', false);
				if(currentPagePost >= res.max) {
					button.hide();
				}
				content.append(res.html);

                sal();
			}
		});
	});

	// contact form
	if ($('.js-formContactUs').length > 0) {
		let contactForm = document.querySelector('.js-formContactUs .wpcf7');	
	
		contactForm.addEventListener('wpcf7mailsent', function( event ) {
			let contactFormBlock = $('.js-formContactUs').closest('.contactform');
			let contactFormBlockHeight = contactFormBlock.outerHeight();

			contactFormBlock.css({'height': contactFormBlockHeight});

			$('.js-formContactUsHide').hide();
			$('.js-formContactUsSuccess').show();
		}, false );

		$('.js-formContactUsSuccessClose').on('click', function() {
			let contactFormBlock = $('.js-formContactUs').closest('.contactform');
			
			contactFormBlock.css({'height': ''});

			$('.js-formContactUsHide').show();
			$('.js-formContactUsSuccess').hide();

			return false;
		});
	}

    // ai masonry
    $('.ai_solutions_inner').masonry({
        percentPosition: true,
        columnWidth: '.ai_solutions_sizer',
        gutter: 24
    });

    // industries masonry
    $('.ai_industries_inner').masonry({
        percentPosition: true,
        columnWidth: '.ai_industries_sizer',
        gutter: 24
    });

    // consulting solutions
    $('.consulting_solutions_inner').masonry({
        percentPosition: true,
        columnWidth: '.consulting_solutions_sizer',
        gutter: 24
    });

    // products masonry
    $('.products_cols_inner').masonry({
        percentPosition: true,
        columnWidth: '.products_cols_sizer',
        gutter: 24
    });

    // slider cases
    $('.js-sliderCases').slick({
        dots: false,
        prevArrow: $('.js-sliderCasesPrev'),
        nextArrow: $('.js-sliderCasesNext'),
        slidesToShow: 2,
        slidesToScroll: 1,
        variableWidth: true,
        responsive: [
            {
                breakpoint: 1200,
                settings: {
                    slidesToShow: 1
                }
            }
        ]
    });

    // slider blog
    $('.js-sliderBlog').slick({
        dots: false,
        prevArrow: $('.js-sliderBlogPrev'),
        nextArrow: $('.js-sliderBlogNext'),
        slidesToShow: 2,
        slidesToScroll: 1,
        variableWidth: true,
        responsive: [
            {
                breakpoint: 1200,
                settings: {
                    slidesToShow: 1
                }
            }
        ]
    });

    // accordion
    function checkAccordion() {
        $('.js-accordionItem').each(function() {
            if (!$(this).hasClass('active')) {
                $(this).find('.js-accordionContent').hide();
            } else {
                $(this).find('.js-accordionContent').show();
            }
        });
    }
    checkAccordion();

    $(document).on('click', '.js-accordionTitle', function(event) {
        const item = $(this).closest('.js-accordionItem');

        if (item.hasClass('active')) {
            item.find('.js-accordionContent').slideUp(400);
            item.removeClass('active');
        } else {
            item.find('.js-accordionContent').slideDown(400);
            item.addClass('active');
        }

        return false;
    });

    // slider team
    $('.js-sliderTeam').slick({
        infinite: true,
        dots: false,
        slidesToShow: 4,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 1199,
                settings: {
                    slidesToShow: 3,
                }
            },
            {
                breakpoint: 991,
                settings: {
                    slidesToShow: 3,
                }
            },
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 1,
                }
            }
        ]
    });

    // services tabs
    $(document).on('click', '.js-servicesTab', function(event) {
        const allTabs = $('.js-servicesTab');
        const item = $(this);
        const id = $(this).data('id');

        const allContent = $('.js-servicesContent');
        const itemContent = $('.js-servicesContent[data-id="'+id+'"]');

        if (!item.hasClass('active')) {
            allTabs.removeClass('active');
            item.addClass('active');
            
            allContent.removeClass('active');
            itemContent.addClass('active');
        }

        return false;
    });

    // contact us modal
    $('.js-openContactUsModal').on('click', function(){
        $('.js-contactUsModal').arcticmodal({
            overlay: {
                css: {
                    backgroundColor: '#18191F',
                    opacity: .25
                }
            }
        });
    });

    let contactUsModalForm = document.querySelector('.js-contactUsModalForm .wpcf7'); 
    contactUsModalForm.addEventListener( 'wpcf7mailsent', function( event ) {
        $('.js-contactUsModalForm').hide();
        $('.js-contactUsModalForm').closest('.modal-contactus').addClass('success');
        $('.js-contactUsModalFormSuccess').show();
    }, false );

    // slider about cases
    let maxWidth = 767,
    slickAboutCases = {
        nextArrow: $('.js-sliderAboutCasesNext'),
        prevArrow: $('.js-sliderAboutCasesPrev'),
        dots: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        mobileFirst: true,
        responsive: [
            {
                breakpoint: maxWidth,
                settings: 'unslick'
            }
        ]
    },
    slickAboutTeam = {
        arrows: true,
        dots: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        mobileFirst: true,
        responsive: [
            {
                breakpoint: maxWidth,
                settings: 'unslick'
            }
        ]
    },
    runSlick = function() {
        $('.js-sliderAboutCases').slick(slickAboutCases);
        $('.js-sliderAboutTeam').slick(slickAboutTeam);
    };

    runSlick();
    
    $(window).on('resize', function(){
        var width = $(window).width();
        if(width < maxWidth) {
            runSlick();
        }
    });

    // slider life
    $('.js-sliderLife').slick({
        nextArrow: $('.js-sliderLifeNext'),
        prevArrow: $('.js-sliderLifePrev'),
        appendDots: $('.about_life_slider_controls'),
        dots: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        variableWidth: true,
        centerMode: true,
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    variableWidth: false,
                    dots: false,
                    centerMode: false,
                }
            }
        ]
    });

    // careers
    $('.js-careersFilter').each(function() {
        $(this).select2({
            minimumResultsForSearch: -1,
            dropdownParent: $(this).parent()
        });
    });

    $('.js-filterByTag').on('click', function(e) {
        e.preventDefault();

        var tag = $(this).data('tag');
        var $form = $('.page-carrers-hero-filter-form');
        
        $form.find('input[name="tag"]').remove();
        
        $('<input>').attr({
            type: 'hidden',
            name: 'searches',
            value: tag
        }).appendTo($form);
        
        $form.trigger('submit');
    });

    $('.js-resetFilters').on('click', function () {
        var $form = $('.page-carrers-hero-filter-form');
        
        $form.find('input[type="text"], input[type="search"], input[type="hidden"]').val('');
        $form.find('select').val('').trigger('change');
        
        var cleanUrl = window.location.pathname;
        window.history.replaceState({}, '', cleanUrl);
        
        $form.trigger('submit');
    });

    $('.js-loadMorePositions').on('click', function(e) {
        e.preventDefault();

        var $btn = $(this);
        var currentPage = parseInt($btn.data('current-page'));
        var maxPages = parseInt($btn.data('max-pages'));

        if (currentPage >= maxPages) return;

        var $form = $('.page-carrers-hero-filter-form');
        var formData = new FormData($form[0]);
        formData.append('action', 'load_more_vacancies');
        formData.append('page', currentPage + 1);

        $btn.prop('disabled', true).text(careersAjax.loadingText);

        $.ajax({
            url: careersAjax.ajaxUrl,
            type: 'POST',
            data: formData,
            processData: false,
            contentType: false,
            success: function(html) {
                var $container = $('.page-carrers-list-inner');
                
                var $temp = $('<div>').html(html.trim());
                var $newItems = $temp.find('.page-carrers-list-item');

                if ($newItems.length) {
                    $btn.fadeOut(200, function() {
                        $newItems.each(function(index) {
                            var $item = $(this);
                            $item.addClass('fade-enter');
                            $container.append($item);
                            
                            setTimeout(function() {
                                $item.removeClass('fade-enter');
                            }, 50 * index);
                        });

                        $btn.data('current-page', currentPage + 1);
                        
                        if (currentPage + 1 < maxPages) {
                            $btn.prop('disabled', false).text(careersAjax.buttonText).fadeIn(200);
                        } else {
                            $btn.remove();
                        }
                    });
                } else {
                    $btn.remove();
                }
            },
            error: function() {
                alert(careersAjax.errorText);
                $btn.prop('disabled', false).text(careersAjax.buttonText);
            }
        });
    });

    $('.js-openModalApply').on('click', function(){
        $('.js-applyModal').arcticmodal({
            overlay: {
                css: {
                    backgroundColor: '#18191F',
                    opacity: .25
                }
            },
            beforeOpen: function(data, el) {
                el.find('input[name="application_type"][value="my_cv"]').prop('checked', true);
            },
        });
    });

    $('.js-openModalApplyFriend').on('click', function(){
        $('.js-applyModal').arcticmodal({
            overlay: {
                css: {
                    backgroundColor: '#18191F',
                    opacity: .25
                }
            },
            beforeOpen: function(data, el) {
                el.find('input[name="application_type"][value="refer_friend"]').prop('checked', true);
            },
        });
    });

    let applyModalForm = document.querySelector('.js-applyModal .wpcf7'); 
    applyModalForm.addEventListener( 'wpcf7mailsent', function( event ) {
        $('.js-applyModalForm').hide();
        $('.js-applyModalForm').closest('.modal-apply').addClass('success');
        $('.js-applyModalFormSuccess').show();
    }, false );

    // modal file input
    const input = document.getElementById("resume-input");
    const list = document.querySelector(".js-upload-list");
    const errorBox = document.querySelector(".js-upload-error");

    const MAX_FILES = 3;
    const MAX_SIZE = 5 * 1024 * 1024;

    let filesArray = [];

    input.addEventListener("change", (e) => {
        const newFiles = Array.from(e.target.files);

        errorBox.textContent = "";

        if (filesArray.length + newFiles.length > MAX_FILES) {
            errorBox.textContent = errorBox.dataset.errorLimit;
            input.value = "";
            return;
        }

        for (const file of newFiles) {
            if (file.size > MAX_SIZE) {
                errorBox.textContent = errorBox.dataset.errorSize;
                input.value = "";
                return;
            }
        }

        newFiles.forEach(file => {
            filesArray.push(file);
            renderFile(file);
            createHiddenInput(file);
        });

        input.value = "";
    });

    document.addEventListener('wpcf7invalid', function() {
        if (filesArray.length === 0) {
            errorBox.textContent = errorBox.dataset.errorRequired;
        }
    });

    function clearErrorIfNeeded() {
        if (filesArray.length > 0) {
            errorBox.textContent = "";
        }
    }
    
    function createHiddenInput(file) {
        const hidden = document.createElement("input");
        hidden.type = "file";
        hidden.name = "resume[]";
        hidden.style.display = "none";

        const dt = new DataTransfer();
        dt.items.add(file);
        hidden.files = dt.files;

        input.closest("form").appendChild(hidden);

        file._hiddenInput = hidden;
    }

    function renderFile(file) {
        const ext = file.name.split(".").pop().toLowerCase();
        const isValid = ["pdf", "doc", "docx"].includes(ext);

        const item = document.createElement("div");
        item.className = `upload-item ${isValid ? "valid" : "invalid"}`;

        item.innerHTML = `
            <div class="file-name">
                <span>${file.name}</span>
            </div>
            <span class="delete-btn"></span>
        `;

        item.querySelector(".delete-btn").addEventListener("click", () => {
            filesArray = filesArray.filter(f => f !== file);
            if (file._hiddenInput) {
                file._hiddenInput.remove();
            }
            item.remove();
            clearErrorIfNeeded();
        });

        list.appendChild(item);
        clearErrorIfNeeded();
    }

    // vacancy
    $(document).on('click', '.js-copyLink', function (e) {
        e.preventDefault();

        const link = $(this).data('link');

        navigator.clipboard.writeText(link).then(() => {
            $(this).addClass('copied');

            setTimeout(() => {
                $(this).removeClass('copied');
            }, 1500);
        });
    });

});
